export default __webpack_public_path__ + "static/media/banner-img.c8a76f68.png";